import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getPurchaseOrderLinesByPurchaseOrderId = async (purchaseOrderId) => {
  const response = await axiosInstance.get(`${API_URL}/purchase-order-lines`, {    params: { purchaseOrderId },
  });
  return response.data;
};

export const createPurchaseOrderLine = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/purchase-order-lines`, data);
  return response.data;
};

export const updatePurchaseOrderLine = async (id, data) => {
  const response = await axiosInstance.put(`${API_URL}/purchase-order-lines/${id}`, data);
  return response.data;
};

export const deletePurchaseOrderLine = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/purchase-order-lines/${id}`);
  return response.data;
};

export const getPurchaseOrderLineById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/purchase-order-lines/${id}`);
  return response.data;
};
